module.exports = __webpack_public_path__ + "img/soccerboard68.e49653c7.jpg";